var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.chipComponent,{tag:"component",staticClass:"gst-event-status-chip"})}
var staticRenderFns = []

export { render, staticRenderFns }